<template>
    <div class='apply'>
        <div class="title" :class="$vuetify.theme.dark ? '': 'sub-title-l'">{{$t('preference.facility.title')}}</div>
        <div id="facility" style="flex: 1;"></div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
import { reportDevice } from "@/api/index";
import monent from 'moment'
import store from '@/store'
export default {
    data() {
        return {

        };
    },
    props:{
        filterQuery:{
            type:Number,
            default:1
        }
    },
    watch:{
        filterQuery:{
            handler:function (val, oldVal) {
                this.initFacility()
            },
        }

    },
    mounted() {
        this.initFacility()
    },
    methods: {

        initFacility(){
            let startTime = monent().subtract(1,'w').startOf('days').unix()
            let endTime = monent().endOf('days').unix()
            // let endTime = monent().unix()
            if(this.filterQuery == 1){
                startTime = monent().subtract(6,'days').startOf('days').unix()
            }
            if(this.filterQuery == 2){
                startTime = monent().subtract(13,'days').startOf('days').unix()
            }
            if(this.filterQuery == 3){
                startTime = monent().subtract(20,'days').startOf('days').unix()
            }
            if(this.filterQuery == 4){
                startTime = monent().subtract(29,'days').startOf('days').unix()
            }
            if(this.filterQuery == 5){
                startTime = monent().subtract(59,'days').startOf('days').unix()
            }
            if(this.filterQuery == 6){
                startTime = monent().subtract(89,'days').startOf('days').unix()
            }

            let params = {
                startTime:startTime,
                endTime:endTime
            }
            reportDevice(params).then(res=> {
                if (res.code == this.$GLOBA.StatusOK) {
                    let list = []
                    let list2 = []
                    for (let item of res.data) {
                        list.push(item.name)
                        list2.push(item.value)
                    }
                    this.setEcharts(list, list2)
                }else{
                    store.dispatch('snackbar/openSnackbar',{
                        snackbarText: res.message,
                        colorType: 'error'
                    })
                }
            })
        },


        setEcharts(list, list2) {
          //  color: this.$vuetify.theme.dark ? '#9994b0' : '#000'
          console.log(list)

            var chartDom = document.getElementById('facility');
            var myChart = echarts.init(chartDom);
            var option = {
                xAxis: {
                  type: 'category',
                  axisLabel:{
                    color: this.$vuetify.theme.dark ? '#9994b0' : '#000'
                  },
                    data: list,

                },
                yAxis: {
                  type: 'value',
                  axisLabel:{
                    color: this.$vuetify.theme.dark ? '#9994b0' : '#000'
                  },
                },
                tooltip: {
                    trigger : 'axis',
                    formatter: '{b}: {c}('+this.$t('preference.num')+')'
                },
                series: [
                    {
                        data: list2,
                        type: 'bar',
                        barMaxWidth: 40,
                        itemStyle: {
                            normal: {
                            color: function (colors) {
                                var colorList = [
                                    '#5066ed',
                                    '#02d7ff',
                                    '#00d48f',
                                    '#ff8c00',
                                    '#fa5c7c',
                                    '#ffc107',
                                    '#f5222d',
                                    '#a0d911',
                                    '#EC407A',
                                    '#8E24AA',
                                    '#673AB7',
                                    '#3F51B5',
                                    '#2196F3',
                                    '#4CAF50',
                                    '#CDDC39',
                                    '#FFEB3B',
                                    '#FFC107',
                                    '#FF9800',
                                    '#795548',
                                    '#607D8B',
                                ];
                                return colorList[colors.dataIndex];
                            }
                            },
                        }
                    }
                ]
            };
            option && myChart.setOption(option);
        }
    },
}
</script>

<style lang='scss' scoped>
.apply {
    height: 100%;
    display: flex;
    flex-direction: column;
    .title {
        height: 50px;
        line-height: 50px;
        font-size: 16px;
        font-weight: 500;
        padding-left: 33px;
        border-bottom: 1px solid #F0F0F0;
    }
    .sub-title-l {
        color: #031b4e;
    }
}
</style>
